export const SELECT_TYPE = {
  GENERAL: 'general',
  ADDITIONAL: 'additional'
} as const;

export const SKELET_ITEMS_COUNT = 10;

export const COLOR_SCHEME = {
  SECONDARY: 'secondary',
  PRIMARY: 'primary'
} as const;
